// extracted by mini-css-extract-plugin
export default {"container":"Revoked_container__v8JLl"};